export const STYLE_TYPES = ['primary', 'secondary', 'title']

export const SIZES = ['md', 'xmd', 'lg', 'xlg', 'xxlg', 'xxxlg', '4xlg', '5xlg', '6xlg']
